import type { ButtonVariant } from '../../primitives/Button/buttonTypes';

export type ModalActionIntent =
  | 'save'
  | 'edit'
  | 'add'
  | 'approve'
  | 'reject'
  | 'delete'
  | 'submit'
  | 'confirm';

interface ResolvedIntent {
  label: string;
  icon: string;
  variant: ButtonVariant;
  type: 'button' | 'submit';
}

const INTENT_MAP: Record<ModalActionIntent, ResolvedIntent> = {
  save: { label: 'Save', icon: 'check_circle', variant: 'primary', type: 'submit' },
  edit: { label: 'Edit', icon: 'edit', variant: 'primary-outline', type: 'button' },
  add: { label: 'Save', icon: 'check_circle', variant: 'primary', type: 'submit' },
  approve: { label: 'Approve', icon: 'check_circle', variant: 'approve', type: 'button' },
  reject: { label: 'Reject', icon: 'cancel', variant: 'secondary-red', type: 'button' },
  delete: { label: 'Delete', icon: 'delete', variant: 'primary-danger', type: 'button' },
  submit: { label: 'Submit', icon: 'check_circle', variant: 'primary', type: 'submit' },
  confirm: { label: 'Confirm', icon: 'check_circle', variant: 'primary', type: 'button' },
};

export function resolveIntent(
  intent: ModalActionIntent,
  overrides?: Partial<Pick<ResolvedIntent, 'label' | 'icon' | 'variant' | 'type'>>,
): ResolvedIntent {
  const base = INTENT_MAP[intent];
  return {
    label: overrides?.label ?? base.label,
    icon: overrides?.icon ?? base.icon,
    variant: overrides?.variant ?? base.variant,
    type: overrides?.type ?? base.type,
  };
}
